<template>
  <div>
    <div class="custom-search d-flex justify-content-between mb-2">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Trạng thái</label>
          <b-form-select
            @change="onChangeStatus"
            v-model="statusSelected"
            :options="[
              { item: 'all', name: 'Tất cả' },
              { item: 0, name: 'Đang chờ xử lý' },
              { item: 1, name: 'Hoàn tất' },
              { item: 2, name: 'Hủy' },
            ]"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          ></b-form-select>
        </div>
      </b-form-group>
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Tìm kiếm</label>
          <b-form-input
            v-model="searchTxt"
            placeholder="Tìm kiếm"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <vue-good-table
      mode="remote"
      :columns="fields"
      :rows="tableItems"
      :total-rows="pagination.total"
      :is-loading="tableLoading"
      :pagination-options="{
        enabled: true,
      }"
      :line-numbers="true"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'user'">
          {{ props.row.user.username }}
        </span>

        <span v-else-if="props.column.field === 'money'">
          {{ formatPrice(props.row.money) }}
        </span>

        <span v-else-if="props.column.field === 'amount'">
          {{ formatPrice(props.row.amount) }}
        </span>

        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="getStatusVariant(props.row.status)">
            {{ getStatusText(props.row.status) }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'createdAt'">
          {{ formatDateTime(props.row.createdAt) }}
        </span>
        <!-- actions  -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="showApprovalModal(props.row)">
                <feather-icon icon="EditIcon" class="mr-50" />
                <span>Duyệt giao dịch</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <!-- end actions -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Showing 1 to</span>
            <b-form-select
              v-model="pagination.perPage"
              :options="['10', '20', '50']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap">of {{ props.total }} entries</span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pagination.perPage"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>

      <div slot="emptystate" class="text-center">
        Không có dữ liệu để hiển thị.
      </div>

      <div slot="loadingContent">
        <b-spinner variant="primary" />
      </div>
    </vue-good-table>

    <b-modal v-model="isShowApprovalModal" title="Duyệt giao dịch" centered>
      <template v-if="rowSelected">
        <b-form-group label-cols="6" label-cols-lg="4" label="ID" class="mb-0">
          <b-form-input
            size="sm"
            readonly
            :value="rowSelected._id"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="6"
          label-cols-lg="4"
          label="Người dùng"
          class="mb-0"
        >
          <b-form-input
            size="sm"
            readonly
            :value="rowSelected.user.username"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="6"
          label-cols-lg="4"
          label="Số tiền"
          class="mb-0"
        >
          <b-form-input
            size="sm"
            readonly
            :value="rowSelected.amount"
          ></b-form-input>
        </b-form-group>
      </template>
      <b-form-group label-cols="4" label-cols-lg="2" label="Lý do:">
        <b-form-input size="sm" v-model="approvalFormData.note"></b-form-input>
      </b-form-group>
      <template #modal-footer>
        <b-button variant="danger" @click="approveTransaction(2)"
          >Từ chối</b-button
        >
        <b-button variant="success" @click="approveTransaction(1)"
          >Đồng Ý</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BPagination,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BModal,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BBadge,
  VBTooltip,
  BListGroup,
  BListGroupItem,
  BCardText,
} from "bootstrap-vue";

import debounce from "lodash.debounce";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { formatDateTime, formatPrice } from "@/helpers/format";
import LoadingButton from "@/@core/components/loading-button/LoadingButton.vue";
import API from "@/api";
import vSelect from "vue-select";

export default {
  props: {
    type: { type: String, default: "deposit" },
  },
  components: {
    BPagination,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    BModal,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    VueGoodTable,
    BBadge,
    LoadingButton,
    vSelect,
    BListGroup,
    BListGroupItem,
    BCardText,
  },

  data() {
    return {
      fields: [
        // {
        //   field: "id",
        //   label: "Id",
        // },
        {
          field: "user",
          label: "Tên đăng nhập",
        },
        {
          field: "balance",
          label: "Số dư",
        },

        {
          field: "amount",
          label: "Số tiền",
        },

        {
          field: "status",
          label: "Trạng thái",
        },

        {
          field: "createdAt",
          label: "Ngày tạo",
        },

        {
          field: "action",
          label: "Hành động",
        },
      ],

      tableItems: [],
      tableLoading: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
      },
      statusSelected: "all",
      rowSelected: null,
      isShowApprovalModal: false,
      approvalFormData: {
        note: "",
      },
      searchTxt: "",
    };
  },

  computed: {},

  directives: {
    "b-tooltip": VBTooltip,
  },

  methods: {
    formatDateTime,
    formatPrice,
    onSearch: debounce(function () {
      this.fetchTableData(1, this.pagination.perPage);
    }, 500),

    onChangeStatus(value) {
      this.fetchTableData(1, this.pagination.perPage);
    },

    fetchTableData(page, size) {
      this.tableLoading = true;
      const type = this.type;
      const params = { type, page, size };
      if (this.statusSelected !== "all") {
        params.status = this.statusSelected;
      }
      if (this.searchTxt) {
        params.username = this.searchTxt;
      }
      this.$http
        .get(API.TRANSACTION_LIST, { params })
        .then((res) => {
          this.tableItems = res.data;
          this.$set(this.pagination, "total", res.total);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    onPerPageChange({ currentPerPage }) {
      this.fetchTableData(1, currentPerPage);
    },
    onPageChange({ currentPage, currentPerPage }) {
      this.fetchTableData(currentPage, currentPerPage);
    },

    showApprovalModal(row) {
      this.rowSelected = row;
      this.approvalFormData = { note: "" };
      this.isShowApprovalModal = true;
    },

    approveTransaction(status) {
      const confirmTitle = `Bạn có chắc chắn "${
        status == 1 ? "đồng ý" : "từ chối"
      }" giao dịch này?`;
      const confirmContent = `${status == 1 ? "Đồng ý" : "Từ chối"} giao dịch`;
      this.$bvModal
        .msgBoxConfirm(confirmTitle, {
          title: confirmContent,
          size: "sm",
          buttonSize: "sm",
          okVariant: status == 1 ? "success" : "danger",
          okTitle: status == 1 ? "Đồng ý" : "Từ chối",
          cancelTitle: "Thoát",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.submitApprovelTransaction(status);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    async submitApprovelTransaction(status) {
      try {
        const id = this.rowSelected?._id;
        const data = { status, note: this.approvalFormData.note };
        const res = await this.$http.patch(
          API.TRANSACTION_APPROVAL + `/${id}`,
          data
        );
        if (res.success) {
          Object.assign(this.rowSelected, res.data);
          this.isShowApprovalModal = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Duyệt giao dịch thành công",
              icon: "CheckIcon",
              variant: "success",
            },
          });
        } else {
          throw res
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message || "Lỗi",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },

    getStatusText(value) {
      switch (value) {
        case 0:
          return "Đang chờ xử lý";
        case 1:
          return "Hoàn tất";
        case 2:
          return "Hủy";
        default:
          return "N/A";
      }
    },

    getStatusVariant(value) {
      switch (value) {
        case 0:
          return "warning";
        case 1:
          return "success";
        case 2:
          return "danger";
        default:
          return "N/A";
      }
    },
  },

  watch: {
    searchTxt(value) {
      this.onSearch();
    },
  },
  created() {
    this.fetchTableData(1, this.pagination.perPage);
  },

  mounted() {
    this.$store.dispatch("verticalMenu/updateUnread", { deposit: 0})
  }
};
</script>
